<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <custom-modal
        title="Create Income"
        @onSubmit="save"
        @onClose="close"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer">
          <v-row>
            <v-col cols="8">
              <v-radio-group v-model="Income.income_for" row>
                <v-radio label="Shop" value="Shop"></v-radio>
                <v-radio label="Warehouse" value="Warehouse"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="4">
              <ValidationProvider rules="required" name="Date" v-slot="{ errors }">
                <datePickComponent
                  hide-details="auto"
                  v-model="Income.date"
                  labelname="Date"
                  :error-messages="errors"
                  required
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider name="Income Category" rules="required" v-slot="{ errors }">
                <v-autocomplete
                  outlined
                  hide-details="auto"
                  v-model="Income.category_id"
                  item-text="name"
                  item-value="id"
                  :items="incomeCategories"
                  :loading="categoryLoading"
                  :error-messages="errors"
                  label="Income Category"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" v-if="Income.income_for === 'Shop'">
              <ValidationProvider rules="required" name="Shop" v-slot="{ errors }">
                <v-autocomplete
                  outlined
                  hide-details="auto"
                  v-model="Income.shop_id"
                  item-text="name"
                  item-value="id"
                  :items="shops"
                  :error-messages="errors"
                  label="Shop"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6" v-if="Income.income_for === 'Warehouse'">
              <ValidationProvider rules="required" name="Warehouse" v-slot="{ errors }">
                <v-autocomplete
                  outlined
                  hide-details="auto"
                  v-model="Income.warehouse_id"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  :error-messages="errors"
                  label="Warehouse"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="6">
              <ValidationProvider name="Amount" rules="required" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="Income.amount"
                  label="Amount"
                  outlined
                  hide-details="auto"
                  type="number"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ValidationProvider name="Remark" rules="required" v-slot="{ errors }">
                <v-textarea
                  hide-details="auto"
                  label="Remark"
                  v-model="Income.remark"
                  outlined
                  rows="3"
                  :error-messages="errors"
                ></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>
<script>
import datePickComponent from "@/components/base/DateComponent";
import CustomModal from "@/components/base/CustomModal";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Income } from "@/models/Income";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

export default {
  props: {
    visible: { type: Boolean, default: false },
    Income: { type: Object, default: () => new Income() },
  },
  components: { ValidationProvider, ValidationObserver, datePickComponent, CustomModal },
  data: () => ({
    isLoading: false,
    categoryLoading: false,
    incomeCategories: [],
    shops: [],
    warehouses: [],
  }),
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) this.$emit("close");
      },
    },
  },
  methods: {
    close() {
      this.show = false;
      if (this.$refs.observer) this.$refs.observer.reset();
    },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.isLoading = true;
      const payload = {
        income_for: this.Income.income_for,
        shop_id: this.Income.income_for === "Shop" ? this.Income.shop_id : null,
        warehouse_id: this.Income.income_for === "Warehouse" ? this.Income.warehouse_id : null,
        category_id: this.Income.category_id,
        amount: Number(this.Income.amount),
        remark: this.Income.remark,
        date: this.Income.date,
      };
      this.$store
        .dispatch("warehouse/createIncome", payload)
        .then(() => {
          this.$toast.success("Income created successfully");
          this.$emit("afterSave");
          this.isLoading = false;
          this.$emit("close");
        })
        .catch((err) => {
          this.isLoading = false;
          if (err && err.data && err.data.error && this.$refs.observer) {
            this.$refs.observer.setErrors(err.data.error);
          }
          this.$toast.error("Income create failed");
        });
    },
    loadLookups() {
      this.categoryLoading = true;
      this.$store
        .dispatch("sitesetting/GetIncomeCategories")
        .then((res) => {
          this.incomeCategories = (res.data && res.data.data) || [];
          this.categoryLoading = false;
        })
        .catch(() => {
          this.categoryLoading = false;
        });
      this.$store.dispatch("warehouse/GetShops", { status: "active" }).then((res) => {
        this.shops = res || [];
      });
      this.$store.dispatch("warehouse/GetWarehouse", { status: "active" }).then((res) => {
        this.warehouses = res || [];
      });
    },
  },
  created() {
    this.loadLookups();
  },
};
</script>
